'use client';

import { textStyles } from '@/ui';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { imageMetaConverter } from '@lib/server';
import { cn } from '@lib/utils/cn';
import { NavigationMenuLink } from '@radix-ui/react-navigation-menu';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { NestedRepeaterLink, TransformedImageType } from '@types';

import { Button } from '../../components/button';

export function SubMenuList({
  menuStack,
  link,
  setMenuStack,
  setCurrentImage,
}: {
  menuStack: NestedRepeaterLink;
  link: NestedRepeaterLink;
  setMenuStack: (menuStack: NestedRepeaterLink) => void;
  setCurrentImage: (image: TransformedImageType | null) => void;
}) {
  const [parent] = useAutoAnimate();
  const fallbackImage = imageMetaConverter(link.image);

  return (
    <ul
      className="flex flex-col gap-1"
      ref={parent}
      onMouseLeave={() => fallbackImage && setCurrentImage(fallbackImage)}
    >
      {/* Submenu back button */}
      {menuStack.url !== link.url && (
        <li key={link.url}>
          <Button className="w-full justify-start gap-3 px-0" variant={'link'} onClick={() => setMenuStack(link)}>
            <IconChevronLeft size={'1rem'} />
            Back
          </Button>
        </li>
      )}

      {menuStack.subMenu?.map((subLink, i) => {
        const image = imageMetaConverter(subLink.image) || fallbackImage;

        return (
          <li
            key={(subLink.url || '') + i}
            className="flex items-center gap-3"
            onMouseEnter={() => image && setCurrentImage(image)}
          >
            <NavigationMenuLink asChild>
              <Button
                className={cn('font-heading! w-full justify-start px-0', textStyles.h3)}
                variant={'link'}
                href={subLink.url}
                onClick={() => {
                  if (!subLink.url && 'subMenu' in subLink) {
                    setMenuStack(subLink);
                  }
                }}
              >
                {subLink.label}
              </Button>
            </NavigationMenuLink>

            {'subMenu' in subLink && subLink.subMenu ? (
              <Button size={'icon'} variant={'link'} onClick={() => setMenuStack(subLink)}>
                <IconChevronRight size={'1.25rem'} />
              </Button>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
